/**
 * Pedagogical tuning in one place. Thresholds are deliberately transparent so
 * parents and educators can understand (and change) why an estimate is shown.
 */
export const MASTERY_CONFIG = {
  /** Number of most recent first tries used to estimate the current level. */
  recentWindow: 12,
  /** Weighted answers needed before any estimate other than "learning". */
  minEvidence: 5,
  /** Weighted answers needed before "provisional mastery" can be shown. */
  masteryMinEvidence: 10,
  /** Practice spread over at least this many different days (retention). */
  masteryMinDays: 2,
  masteryScore: 0.85,
  progressingScore: 0.65,
  needsPracticeScore: 0.5,
  /** A correct first try after asking for a hint counts as this much. */
  hintCredit: 0.5,
  /** Change between the two halves of the window that counts as a trend. */
  trendDelta: 0.15,
} as const;

/** Spaced repetition: days until the next review for Leitner boxes 0–5. */
export const REVIEW_INTERVAL_DAYS = [0, 1, 3, 7, 16, 35] as const;
export const PROMOTE_SCORE = 0.8;
export const DEMOTE_SCORE = 0.5;

export const DAILY_MISSION = {
  objectives: 3,
  questions: 8,
} as const;

/** Sessions left "in progress" longer than this are closed as abandoned. */
export const ABANDON_AFTER_MS = 6 * 60 * 60 * 1000;

export type MasteryConfig = typeof MASTERY_CONFIG;
